import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProgramsService {
  public programListRef: firebase.database.Reference;
  baseUrl: string;
  constructor(private db: AngularFireDatabase, private http: HttpClient) { 
    this.programListRef = db.database.ref('/com_shelcaster_broadcast_portal');
    this.baseUrl = localStorage.getItem('baseUrl');
  }

  getPrograms() {
    return this.programListRef.child('program_portal').orderByChild('lft');
  }

  getChannels() {
    return this.programListRef.child('channel').orderByChild('lft');
  }

  getNetworks() {
    return this.programListRef.child('network_portal').orderByChild('lft');
  }

  getChannel(channelAlias) {
    return this.programListRef.child(`channel/${channelAlias}`);
  }

  getChannelsApi() {
    return this.http.get(`${this.baseUrl}apis/channels.php`);
  }

  getProgramsApi(channelID, baseUrl) {
    if (this.baseUrl != null) {
      return this.http.get(`${this.baseUrl}apis/programs.php?channelID=${channelID}&baseUrl=${this.baseUrl}`);
    } else {
      return this.http.get(`${baseUrl}apis/programs.php?channelID=${channelID}&baseUrl=${baseUrl}`);
    }
    
  }
}
